// @ts-expect-error: Flow to TS migration.
import queryString from "query-string"

export const getQueryParams = () => {
  // use "URLSearchParams" alternatively
  return queryString.parse(window.location.search.substring(1))
}
